<template>
  <landing-page-form :submit-loading="submitLoading"
                     :title="$t('searchSuggestions.create.title')"
                     @submit="onSubmit">
  </landing-page-form>
</template>
<script>
  import LandingPageForm from 'src/views/admin/content/landing-pages/LandingPageForm'
  import LandingPageService from 'src/services/LandingPageService'

  export default {
    components: {
      LandingPageForm,
    },
    data () {
      return {
        submitLoading: false,
      }
    },
    methods: {
      async onSubmit (data) {
        try {
          this.submitLoading = true
          await LandingPageService.create(data)
          this.$router.push('/content/landing-pages')
        } finally {
          this.submitLoading = false
        }
      },
    },
  }
</script>
<style>
</style>
